import React, { useEffect, useState } from "react";
import {
  Collapse,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@material-ui/core";
import { Inbox as InboxIcon } from "@material-ui/icons";
import { Link } from "react-router-dom";
import classnames from "classnames";
import useStyles from "./styles";
import localStoreUtil from "../../../../utils/localstore.util";

export default function SidebarLink({
  link,
  icon,
  label,
  children,
  location,
  isSidebarOpened,
  nested,
  type,
  handleLogout,
}) {
  var classes = useStyles();

  var [isOpen, setIsOpen] = useState(false);

  var [agentDetail, setAgentDetail] = useState();

  useEffect(() => {
    const checkSetInatailState = async () => {
      const getAgentData = await localStoreUtil.get_data("agent");

      setAgentDetail(getAgentData);
    };

    checkSetInatailState();
  }, []);

  var isLinkActive =
    link &&
    (location.pathname === link || location.pathname.indexOf(link) !== -1);

  if (type === "title")
    return (
      <Typography
        className={classnames(classes.linkText, classes.sectionTitle, {
          [classes.linkTextHidden]: !isSidebarOpened,
        })}
      >
        {label}
      </Typography>
    );

  if (type === "divider") return <Divider className={classes.divider} />;

  if (!children)
    return (
      <ListItem
        button
        component={link && Link}
        to={link}
        className={classes.link}
        disabled={
          (!agentDetail?.isStoreSupervisor &&
            label?.toLowerCase() === "store riders") ||
          (!agentDetail?.isAgent && label?.toLowerCase() === "orders") ||
          label?.toLowerCase() === "dashboard" ||
          label?.toLowerCase() === "employee management" ||
          label?.toLowerCase() === "reports" ||
          label?.toLowerCase() === "goals"
            ? true
            : false
        }
        style={
          (agentDetail?.isAgent && label?.toLowerCase() === "dashboard") ||
          (agentDetail?.isAgent &&
            label?.toLowerCase() === "employee management") ||
          (agentDetail?.isAgent && label?.toLowerCase() === "reports") ||
          (agentDetail?.isAgent && label?.toLowerCase() === "goals")
            ? { color: "gray", borderBottom: "1px solid gray" }
            : !agentDetail?.isStoreSupervisor &&
              label?.toLowerCase() === "store riders"
            ? { display: "none" }
            : !agentDetail?.isSupervisor &&
              label?.toLowerCase() === "agent management"
            ? { display: "none" }
            : (!agentDetail?.isAgent && label?.toLowerCase() === "dashboard") ||
              (!agentDetail?.isAgent && label?.toLowerCase() === "orders") ||
              (!agentDetail?.isAgent &&
                label?.toLowerCase() === "employee management") ||
              (!agentDetail?.isAgent && label?.toLowerCase() === "reports") ||
              (!agentDetail?.isAgent && label?.toLowerCase() === "goals")
            ? { display: "none" }
            : { borderBottom: "1px solid gray" }
        }
        onClick={() => {
          if (label?.toLowerCase() === "logout") {
            handleLogout();
          }
        }}
        classes={{
          root: classnames(classes.linkRoot, {
            [classes.linkActive]: isLinkActive && !nested,
            [classes.linkNested]: nested,
          }),
        }}
        disableRipple
      >
        <ListItemText
          className={
            isLinkActive ? classes.drawerLinkActive : classes.drawerLink
          }
          primary={label}
        />
      </ListItem>
    );
  return (
    <>
      <ListItem
        button
        component={link && Link}
        onClick={toggleCollapse}
        className={classes.link}
        to={link}
        disableRipple
      >
        <ListItemIcon
          className={classnames(classes.linkIcon, {
            [classes.linkIconActive]: isLinkActive,
          })}
        >
          {icon ? icon : <InboxIcon />}
        </ListItemIcon>
        <ListItemText
          classes={{
            primary: classnames(classes.linkText, {
              [classes.linkTextActive]: isLinkActive,
              [classes.linkTextHidden]: !isSidebarOpened,
            }),
          }}
          primary={label}
        />
      </ListItem>

      {children && (
        <Collapse
          in={isOpen && isSidebarOpened}
          timeout="auto"
          unmountOnExit
          className={classes.nestedList}
        >
          <List component="div" disablePadding>
            {children.map((childrenLink) => (
              <SidebarLink
                key={childrenLink && childrenLink.link}
                location={location}
                isSidebarOpened={isSidebarOpened}
                classes={classes}
                nested
                {...childrenLink}
              />
            ))}
          </List>
        </Collapse>
      )}
    </>
  );
  // ###########################################################
  function toggleCollapse(e) {
    if (isSidebarOpened) {
      e.preventDefault();
      setIsOpen(!isOpen);
    }
  }
}
